import { render, staticRenderFns } from "./AllClients.vue?vue&type=template&id=24850d72&"
import script from "./AllClients.vue?vue&type=script&lang=js&"
export * from "./AllClients.vue?vue&type=script&lang=js&"
import style0 from "./AllClients.vue?vue&type=style&index=0&id=24850d72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports